import ArticleLayout from '@/components/feature/ArticleLayout';
import { oopbuyArticleContent } from '@/mocks/seoContent';

export default function OopbuyArticle() {
  return (
    <ArticleLayout
      article={oopbuyArticleContent}
      heroImage="https://readdy.ai/api/search-image?query=Warm%20inviting%20home%20workspace%20with%20tablet%20and%20open%20notebook%2C%20cream%20ceramic%20mug%2C%20small%20potted%20plant%2C%20soft%20morning%20sunlight%20streaming%20through%20window%2C%20beige%20and%20warm%20white%20color%20palette%2C%20editorial%20lifestyle%20photography%2C%20clean%20cozy%20composition%2C%20inviting%20atmosphere&width=1200&height=600&seq=article-oopbuy-hero-v3&orientation=landscape"
      heroImageAlt="Oopbuy Spreadsheet beginner's gateway to smart product discovery"
      heroImageTitle="Oopbuy Spreadsheet 2026 Complete Guide"
      tag="Beginner's Guide"
      relatedArticles={[
        { title: "Hipobuy Spreadsheet Guide", slug: "hipobuy-spreadsheet-guide" },
        { title: "Kakobuy Spreadsheet Guide", slug: "kakobuy-spreadsheet" },
        { title: "CSSBuy Spreadsheet Guide", slug: "cssbuy-spreadsheet" },
        { title: "Superbuy Spreadsheet Guide", slug: "superbuy-spreadsheet" },
      ]}
    />
  );
}